<template>
    <section>
        <div class="page-wrap">
            <div class="container">
                <div class="box-content">
                    <h2>Frequently Asked Questions</h2>
                    <div class="faq-height">
                        <!-- Nav tabs -->
                        <ul class="nav nav-tabs faq-nav-tabs" role="tablist">
                            <li role="presentation" class="active"><a href="#tab-inscription" aria-controls="tab-inscription" role="tab" data-toggle="tab">Inscription/Engraving</a></li>
                            <li role="presentation"><a href="#tab-order" aria-controls="tab-order" role="tab" data-toggle="tab">Order/Payment</a></li>
                            <li role="presentation"><a href="#tab-quantity" aria-controls="tab-quantity" role="tab" data-toggle="tab">Quantity/Location</a></li>
                            <li role="presentation"><a href="#tab-replicas" aria-controls="tab-replicas" role="tab" data-toggle="tab">Keepsake Items</a></li>
                        </ul>
                        <!-- Tab panes -->
                        <div class="tab-content faq-tab-content">
                            <div role="tabpanel" class="tab-pane active" id="tab-inscription">
                                <div class="accordion" id="accordion-inscription">
                                    <div class="accordion-group">
                                        <div class="accordion-heading">
                                            <a class="accordion-toggle collapsed" data-toggle="collapse" href="#collapse-1">What are people putting on their bricks?</a>
                                        </div>
                                        <div id="collapse-1" class="accordion-body collapse">
                                            <div class="accordion-inner">
                                                <a class="text-danger pointer" v-on:click="showInscriptionExamples()">Click here</a> to view inscription examples to nudge your creativity.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-group">
                                        <div class="accordion-heading">
                                            <a class="accordion-toggle collapsed" data-toggle="collapse" href="#collapse-2">What can I have engraved on my brick?</a>
                                        </div>
                                        <div id="collapse-2" class="accordion-body collapse">
                                            <div class="accordion-inner">
                                                Any letter, number, symbol or punctuation mark found on a standard English keyboard can be engraved. Discriminatory, political, offensive or unsuitable messages as determined by Prosper ISD will be declined. Prosper ISD reserves the right to decline inscriptions for any reason. Should your inscription require revision, you will be contacted for assistance in submitting an alternative inscription.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-group">
                                        <div class="accordion-heading">
                                            <a class="accordion-toggle collapsed" data-toggle="collapse" href="#collapse-3">How will my inscription appear on my brick?</a>
                                        </div>
                                        <div id="collapse-3" class="accordion-body collapse">
                                            <div class="accordion-inner">
                                                All text will be centered and engraved in UPPERCASE, except if requested for proper name formatting (i.e., McKENZIE, DeBOUR, etc.).
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-group">
                                        <div class="accordion-heading">
                                            <a class="accordion-toggle collapsed" data-toggle="collapse" href="#collapse-4">How long can my message be?</a>
                                        </div>
                                        <div id="collapse-4" class="accordion-body collapse">
                                            <div class="accordion-inner">
                                                <p>4” x 8” bricks can be engraved with one to three (1-3) lines of text with up to sixteen (16) characters per line.</p>
                                                <p>8” x 8” bricks can be engraved with one to six (1-6) lines of text with up to sixteen (16) characters per line.</p>
                                                <p>8” x 8” bricks with the PEAGLE or PTORCH DISTRICT logo can be engraved with one to four (1-4) lines of text with up to sixteen (16) characters per line.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-group">
                                        <div class="accordion-heading">
                                            <a class="accordion-toggle collapsed" data-toggle="collapse" href="#collapse-5">Can I change my inscription?</a>
                                        </div>
                                        <div id="collapse-5" class="accordion-body collapse">
                                            <div class="accordion-inner">
                                                Changes may be made to your order within 1 business day of receipt of your order confirmation, after which your order may be scheduled for production and changes may not be possible.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div role="tabpanel" class="tab-pane" id="tab-order">
                                <div class="accordion" id="accordion-order">
                                    <div class="accordion-group">
                                        <div class="accordion-heading">
                                            <a class="accordion-toggle collapsed" data-toggle="collapse" href="#collapse-8">How do I place an order if I live in Alaska, Hawaii, or internationally?</a>
                                        </div>
                                        <div id="collapse-8" class="accordion-body collapse">
                                            <div class="accordion-inner">
                                                Please call 1-833-291-2622 and a customer service specialist will be happy to assist you in placing your order. Additional shipping charges will be quoted and applied at checkout.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-group">
                                        <div class="accordion-heading">
                                            <a class="accordion-toggle collapsed" data-toggle="collapse" href="#collapse-9">How long do I have to place my order?</a>
                                        </div>
                                        <div id="collapse-9" class="accordion-body collapse">
                                            <div class="accordion-inner">
                                                Space is limited, so act now to ensure you are included in this exciting opportunity!
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-group">
                                        <div class="accordion-heading">
                                            <a class="accordion-toggle collapsed" data-toggle="collapse" href="#collapse-10">What do I do if I haven't received my email order confirmation?</a>
                                        </div>
                                        <div id="collapse-10" class="accordion-body collapse">
                                            <div class="accordion-inner">
                                                If you have not received your confirmation email, please check your junk folder. If you still cannot locate your confirmation, please call 1-833-291-2622 for additional assistance.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-group">
                                        <div class="accordion-heading">
                                            <a class="accordion-toggle collapsed" data-toggle="collapse" href="#collapse-11">Are gift certificates available?</a>
                                        </div>
                                        <div id="collapse-11" class="accordion-body collapse">
                                            <div class="accordion-inner">
                                                Yes, gift certificates are available. To order a gift certificate for redemption at a later date, please visit the Shop page or call 1-833-291-2622.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-group">
                                        <div class="accordion-heading">
                                            <a class="accordion-toggle collapsed" data-toggle="collapse" href="#collapse-12">Will sales tax be applied to my order?</a>
                                        </div>
                                        <div id="collapse-12" class="accordion-body collapse">
                                            <div class="accordion-inner">
                                                8.25% sales tax will be applied to all purchases.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-group">
                                        <div class="accordion-heading">
                                            <a class="accordion-toggle collapsed" data-toggle="collapse" href="#collapse-14">How do I pay by check?</a>
                                        </div>
                                        <div id="collapse-14" class="accordion-body collapse">
                                            <div class="accordion-inner">
                                                <p>Please call 1-833-291-2622 to receive an order form which can be completed and mailed along with your check payment.</p>
                                                <p>Please make checks payable to: Prosper ISD Stadium Brick Program</p>
                                                <p>Please mail completed order form and check to: PISD Stadium Champions Walk • Fulfillment Center • 615 E. 43rd St. • Boise, ID 83714</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-group">
                                        <div class="accordion-heading">
                                            <a class="accordion-toggle collapsed" data-toggle="collapse" href="#collapse-15">What do the proceeds of my order benefit?</a>
                                        </div>
                                        <div id="collapse-15" class="accordion-body collapse">
                                            <div class="accordion-inner">
                                                The PISD Stadium Champions Walk is officially provided by Prosper ISD, with net proceeds benefiting Prosper.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div role="tabpanel" class="tab-pane" id="tab-quantity">
                                <div class="accordion" id="accordion-quantity">
                                    <div class="accordion-group">
                                        <div class="accordion-heading">
                                            <a class="accordion-toggle collapsed" data-toggle="collapse" href="#collapse-17">How many bricks are available?</a>
                                        </div>
                                        <div id="collapse-17" class="accordion-body collapse">
                                            <div class="accordion-inner">
                                                Space is limited, so act now to ensure you are included in this exciting opportunity!
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-group">
                                        <div class="accordion-heading">
                                            <a class="accordion-toggle collapsed" data-toggle="collapse" href="#collapse-18">How will I find my installed brick?</a>
                                        </div>
                                        <div id="collapse-18" class="accordion-body collapse">
                                            <div class="accordion-inner">
                                                Once installed, you wil receive a notification with further instruction on how to find your brick.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-group">
                                        <div class="accordion-heading">
                                            <a class="accordion-toggle collapsed" data-toggle="collapse" href="#collapse-181">When will my brick be installed?</a>
                                        </div>
                                        <div id="collapse-181" class="accordion-body collapse">
                                            <div class="accordion-inner">
                                                The engraved bricks are tentatively scheduled to be installed in Summer/Fall 2019.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-group">
                                        <div class="accordion-heading">
                                            <a class="accordion-toggle collapsed" data-toggle="collapse" href="#collapse-19">Where will my brick be installed?</a>
                                        </div>
                                        <div id="collapse-19" class="accordion-body collapse">
                                            <div class="accordion-inner">
                                                Bricks will be featured at the new Prosper ISD stadium set to open in Fall of 2019.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div role="tabpanel" class="tab-pane" id="tab-replicas">
                                <div class="accordion" id="accordion-replicas">
                                    <div class="accordion-group">
                                        <div class="accordion-heading">
                                            <a class="accordion-toggle collapsed" data-toggle="collapse" href="#collapse-22">What is a replica brick?</a>
                                        </div>
                                        <div id="collapse-22" class="accordion-body collapse">
                                            <div class="accordion-inner">
                                                A replica is a duplicate of your brick, made from the same material and engraved with your personalized message. Proudly showcase your Prosper pride with a replica. These special edition items are perfect gifts for graduations, holidays, birthdays and more! They also include a commemorative plaque affixed to the top! Colors may vary slightly.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-group">
                                        <div class="accordion-heading">
                                            <a class="accordion-toggle collapsed" data-toggle="collapse" href="#collapse-23">What is a display case?</a>
                                        </div>
                                        <div id="collapse-23" class="accordion-body collapse">
                                            <div class="accordion-inner">
                                                Display cases are laser-engraved with Prosper ISD artwork and allow you to proudly display your replica brick.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-group">
                                        <div class="accordion-heading">
                                            <a class="accordion-toggle collapsed" data-toggle="collapse" href="#collapse-24">What is a keepsake certificate?</a>
                                        </div>
                                        <div id="collapse-24" class="accordion-body collapse">
                                            <div class="accordion-inner">
                                                Keepsake certificates are frameable certificates customized with your brick message. This not only authenticates your purchase but also can be given as a gift. Keepsake certificates are mailed within 2-4 weeks of your purchase.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-group">
                                        <div class="accordion-heading">
                                            <a class="accordion-toggle collapsed" data-toggle="collapse" href="#collapse-25">Can keepsake items be shipped to a different address?</a>
                                        </div>
                                        <div id="collapse-25" class="accordion-body collapse">
                                            <div class="accordion-inner">
                                                Yes, with the exception of P.O. boxes or APO’s.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-group">
                                        <div class="accordion-heading">
                                            <a class="accordion-toggle collapsed" data-toggle="collapse" href="#collapse-26">When will I receive my replica brick and display case?</a>
                                        </div>
                                        <div id="collapse-26" class="accordion-body collapse">
                                            <div class="accordion-inner">
                                                Please allow 10-12 weeks for creation and shipping of your brick. To expedite your order please call 1-833-291-2622.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-group">
                                        <div class="accordion-heading">
                                            <a class="accordion-toggle collapsed" data-toggle="collapse" href="#collapse-27">How do I order additional keepsake items after I have placed my initial order?</a>
                                        </div>
                                        <div id="collapse-27" class="accordion-body collapse">
                                            <div class="accordion-inner">
                                                Please call 1-833-291-2622 to place your order with a customer service specialist.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script type="text/jsx">
    import { Event } from '../../../../assets/js/components/frontend/event.vue'
    export default {
        name: 'faq',
        methods: {
            showInscriptionExamples: function () {
                Event.$emit('inscriptionExamplesPopup');
            }
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// Faq.vue?60437745